const locale = {
	// #region Logs fields
	LOGS_COLUMN_TYPE: 'Tipo Log',
	LOGS_COLUMN_ITEM_TABLE: 'Tipo elemento',
	LOGS_COLUMN_ITEM_TITLE: 'Elemento',
	LOGS_COLUMN_USER: 'Utente',
	LOGS_COLUMN_DATE: 'Data',
	LOGS_COLUMN_LOGIN_DATE: 'Data login',
	LOGS_COLUMN_ITEM_PAYLOAD: 'Payload'
	// #endregion
};

export default locale;
